module.exports = __webpack_public_path__ + "static/sold-5863da20f3ba199a7784e08bcb95d503.svg";